import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loginWithPasswordWatcher } from "../../redux/actions/loginactioncreators";
import { MfaPageContainer } from "./MfaPageContainer";

export default function MfaForceDisabled() {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.loginForm.username);
  const password = useSelector((state) => state.loginForm.password);
  const accountNumber = useSelector((state) => state.loginForm.accountNumber);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginWithPasswordWatcher({
      username: username,
      password: password,
      accountNumber: accountNumber
    }));
  }

  const InstructionalText = () => {
    return (
      <Fragment>
        <FormattedMessage
          id="mfa.forceDisabledActionRequiredBlurb"
          defaultMessage="To enhance security and align with your organization's updated authentication policy, one of the previously supported multi-factor authentication (MFA) methods has been disabled."
          description="Explanation that an MFA method has been disabled due to policy changes"
        />
        <br/>
        <FormattedMessage
          tagName="div"
          id="mfa.forceDisabledWhatThisMeans"
          defaultMessage="What This Means for You:"
          description="Section header explaining impact to user"
        />
        <FormattedMessage
          tagName="div"
          id="mfa.forceDisabledUnsupportedBlurb"
          defaultMessage="You are currently using a method that is no longer supported for login. To continue accessing our system, you will need to set up an alternate MFA method."
          description="Explanation that user's current MFA method is no longer supported"
        />
        <FormattedMessage
          tagName="div"
          id="mfa.forceDisabledNoAction"
          defaultMessage="If you've already configured the alternate MFA method, no action is required."
          description="Information that no action is needed if alternate MFA is already configured"
        />
        <FormattedMessage
          tagName="div"
          id="mfa.forceDisabledAppreciation"
          defaultMessage="We appreciate your understanding as we continue to support your organization's security requirements. If you encounter any issues or need assistance, please contact our support team."
          description="Thank you message and support contact information"
        />
      </Fragment>
    )
  }

  return (
    <MfaPageContainer
      onSubmit={handleSubmit}
      showErrors={true}
      headerText={<FormattedMessage id="mfa.forceDisabledActionRequired" defaultMessage="Action Required: Update to Your Multi-Factor Authentication (MFA) Settings" description="Title for page informing user that MFA settings need to be updated" />}
      instructionalText={<InstructionalText />}
      submitButtonText={<FormattedMessage id="mfaSetup.continueButton" defaultMessage="Continue" description="Submit multi-factor authentication selection" />}
      otpValidator={true}
    >
    </MfaPageContainer>
  )
}